import styled from 'styled-components'
import { Modal, Input, Button, Typography } from 'antd'
import { RightOutlined } from '@ant-design/icons'

const { Text } = Typography

export const StyledModal = styled(Modal)`
    & .ant-modal-header {
        background: linear-gradient(135deg, #f0f7f0 0%, #ffffff 100%);
        border-bottom: 2px solid #7BAD7E;
        padding: 20px 24px;
    }
    & .ant-modal-title {
        font-size: 18px;
        font-weight: 700;
        color: #7BAD7E;
        letter-spacing: -0.01em;
    }
    & .ant-modal-body {
        padding: 20px 24px;
    }
`

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
`

export const StyledSearch = styled(Input)`
    flex: 1;
    height: 38px;
    border-radius: 8px;
    border-color: #e8e8e8;
    font-size: 14px;

    &:hover,
    &:focus {
        border-color: #7BAD7E;
        box-shadow: 0 0 0 2px rgba(123, 173, 126, 0.15);
    }

    & .ant-input-prefix {
        margin-right: 8px;
    }
`

export const CountBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #7BAD7E;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 12px;
    padding: 2px 10px;
    white-space: nowrap;
    flex-shrink: 0;
`

export const AddButton = styled(Button)`
    border-radius: 6px;
    padding: 0 14px;
    height: 38px;
    background-color: #7BAD7E;
    border: none;
    color: white;
    font-weight: 600;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    transition: background-color 0.2s;

    &:hover,
    &:focus {
        background-color: #5F8C6C;
        border-color: transparent;
        color: white;
    }
`

export const ListContainer = styled.div`
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 3px 0px 20px rgba(0, 0, 0, 0.07);
    min-height: 480px;
    max-height: 480px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: #f5f5f5;
    }
    &::-webkit-scrollbar-thumb {
        background: #c8dfc9;
        border-radius: 3px;
    }
`

export const CompoundRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background: #fff;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;
    border-left: 3px solid transparent;
    transition: background-color 0.15s, border-left-color 0.15s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: #f7fbf7;
        border-left-color: #7BAD7E;
    }
`

export const CompoundName = styled(Text)`
    font-size: 14px;
    font-weight: 600;
    color: #171c2f;
`

export const ChevronIcon = styled(RightOutlined)`
    font-size: 11px;
    color: #b0b0b0;
    transition: color 0.15s, transform 0.15s;

    ${CompoundRow}:hover & {
        color: #7BAD7E;
        transform: translateX(2px);
    }
`

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 480px;
    background: #fafafa;
    border-radius: 10px;
    box-shadow: 3px 0px 20px rgba(0, 0, 0, 0.07);
`

export const SecondaryButton = styled(Button)`
    border-radius: 6px;
    padding: 0 16px;
    height: 36px;
    background-color: #e1e1e1;
    border: none;
    color: #424647;
    font-weight: 500;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s, color 0.2s;

    &:hover,
    &:focus {
        background-color: #bcbcbc;
        border-color: transparent;
        color: white;
    }
`